import { useEffect, useState } from "react";
import { AlertTriangle, Clock3, RefreshCw, X } from "lucide-react";

export default function MaintenanceOverlay({ open = true, fatal = false, onDismiss, onRetry }) {
  const [seconds, setSeconds] = useState(600);

  useEffect(() => {
    if (!open) return undefined;
    setSeconds(600);
    const timer = setInterval(() => {
      setSeconds((value) => Math.max(0, value - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [open]);

  if (!open) return null;

  const minutes = String(Math.floor(seconds / 60)).padStart(2, "0");
  const secs = String(seconds % 60).padStart(2, "0");

  return (
    <div className="fixed inset-0 z-[120] grid place-items-center bg-black/80 p-4 backdrop-blur-md">
      <div className="w-full max-w-md rounded-2xl border border-[#D4AF37]/40 bg-[#07100B] p-6 text-white shadow-2xl shadow-black/70">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="grid h-12 w-12 place-items-center rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/15">
              <AlertTriangle className="h-5 w-5 text-[#D4AF37]" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.22em] text-[#D4AF37]">Maintenance</p>
              <h2 className="font-display text-2xl font-black leading-tight">Website under maintenance</h2>
            </div>
          </div>
          {!fatal && (
            <button type="button" onClick={onDismiss} className="rounded-full p-2 text-white/50 hover:bg-white/10 hover:text-white">
              <X className="h-4 w-4" />
            </button>
          )}
        </div>

        <p className="mt-5 text-sm leading-relaxed text-white/65">
          Please check back in about 10 minutes. Our team is working to restore access as quickly as possible.
        </p>

        <div className="mt-5 flex items-center justify-between rounded-xl border border-white/10 bg-black/30 px-4 py-3">
          <div className="flex items-center gap-2 text-sm text-white/60">
            <Clock3 className="h-4 w-4 text-[#D4AF37]" />
            Estimated wait
          </div>
          <div className="font-mono text-lg font-bold text-[#F1C40F]">{minutes}:{secs}</div>
        </div>

        <button
          type="button"
          onClick={onRetry || (() => window.location.reload())}
          className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#D4AF37] px-5 py-3 font-bold text-black hover:bg-[#F1C40F]"
        >
          <RefreshCw className="h-4 w-4" />
          Try again
        </button>
      </div>
    </div>
  );
}
